import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { Divider } from '@mui/material';
import { Title, DetailPopup } from 'shared/components';
import { Content, Item, Header } from './styles';
import TemplateCard from '../TemplateCard';
import CardSettings from '../CardSettings';
import DonationsDummy from '../../utils/images/DonationsDummy.png';
import BeneficiariesDummy from '../../utils/images/BeneficiariesDummy.png';
import ReportingDummy from '../../utils/images/ReportingDummy.png';
import DataQualityDummy from '../../utils/images/DataQualityDummy.png';
import ImpactsDummy from '../../utils/images/ImpactsDummy.png';

const TEMPLATES = [
  {
    id: uuidv4(),
    title: 'Impacts',
    description:
      'Impacts are the impacts your funded programs are making on the world.  You will be able to view these impacts by the number ' +
        'of impacts you can claim (i.e. that your donations have paid for), by social ROI, and by how much you are leveraging ' +
        'foundational investments.  You will also be able to view these by year, portfolio, or portfolio manager, and drill down to ' +
        'specific nonprofits and programs in those silos.',
    src: ImpactsDummy
  },
  {
    id: uuidv4(),
    title: 'Donations',
    description:
      'Donations are the investments in cash, time, goods, and services that you make in your nonprofits funded programs.  You will ' +
        'be able to see these donations by portfolio, by service, and by portfolio manager, as well as compare how donations across ' +
        'these silos are changing over time, as well as drill down to specific nonprofits and programs in those silos.',
    src: DonationsDummy
  },
  {
    id: uuidv4(),
    title: 'Reporting Compliance',
    description:
      'Reporting Compliance is a metric that tells you how many of your funded programs are reporting on time, with a comparison and ' +
        'drilldown capability to see which nonprofits and programs are lagging behind in the reporting process.',
    src: ReportingDummy
  },
  {
    id: uuidv4(),
    title: 'Data Quality',
    description:
      'Data quality tells you how rigorously your nonprofits are measuring the impact data they are providing to you.  A percentage ' +
        'metric tells you exactly how well the different portfolios, services, and managers are being measured, and how they are ' +
        'changing over time.  You will also be able to drill down by silo to see which nonprofits and reports are driving those ' +
        'metrics.',
    src: DataQualityDummy
  },
  {
    id: uuidv4(),
    title: 'Beneficiaries',
    description:
      'Beneficiaries tell you which beneficiary groups are benefiting from your donations, and how those groups distribute by silos, ' +
        'including NPO, portfolio, portfolio manager and service.  You will be able to compare over time, as well as drill down to ' +
        'identify which NPOs and programs are reaching which beneficiaries.',
    src: BeneficiariesDummy
  }
];

const TemplatesModal = ({ open, onClose, onAddCard }) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);

  const handleCloseModal = () => {
    setSelectedTemplate(null);
    onClose();
  };

  const handleShowSettings = template => {
    setSelectedTemplate(template);
  };

  const handleOnCloseSettings = () => {
    setSelectedTemplate(null);
  };

  const handleOnSaveSettings = (card, form) => {
    const newCard = { ...card };
    newCard.settings = form;
    setSelectedTemplate(null);
    onAddCard(newCard);
  };

  return (
    <DetailPopup
      open={open}
      onClose={handleCloseModal}
    >
      <Content>
        <Header>
          <Title centered>Templates</Title>
          <Divider />
        </Header>
        {selectedTemplate && (
          <CardSettings
            card={selectedTemplate}
            onDelete={handleOnCloseSettings}
            onClose={handleOnCloseSettings}
            onSave={handleOnSaveSettings}
            positiveButtonText="ADD"
            negativebuttonText="CANCEL"
            title="Configure Card"
            noCloseIcon
            isNew
          />
        )}
        {!selectedTemplate &&
          TEMPLATES.map(template => (
            <Item key={template.id}>
              <TemplateCard
                title={template.title}
                description={template.description}
                src={template.src}
                onClick={() => handleShowSettings(template)}
              />
            </Item>
          ))}
      </Content>
    </DetailPopup>
  );
};

TemplatesModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAddCard: PropTypes.func,
};

export default TemplatesModal;
